export const getFormattedMCQuestions = (questions) => {
	const formattedQuestions = questions.map((q) => {
		const {
			question_id,
			selected,
			reference,
			answer,
			question,
			edited,
			deleted,
			options,
			comments = "",
			images
		} = q || {};
		return {
			question_id,
			selected,
			deleted,
			edited,
			comments,
			...(images && images.length > 0 ? { images } : {}),
			...(edited
				? {
					revised_question: {
						question,
						options,
						answer,
						reference,
						...(images && images.length > 0 ? { images } : {}),
					},
				}
				: {}),
		};
	});

	return formattedQuestions;
};

export const getFormattedFFQuestions = (questions) => {
	const formattedQuestions = questions.map((q) => {
		const { 
			question_id, 
			selected, 
			reference, 
			question, 
			answer, 
			edited, 
			deleted, 
			comments = "",
			images
		} = q || {};
		return {
			question_id,
			selected,
			deleted,
			edited,
			comments,
			...(images && images.length > 0 ? { images } : {}),
			...(edited
				? {
					revised_question: {
						question,
						answer,
						reference,
						...(images && images.length > 0 ? { images } : {}),
					},
				}
				: {}),
		};
	});

	return formattedQuestions;
};

export const getFormattedTFQuestions = (questions) => {
	const formattedQuestions = questions.map((q) => {
		const {
			question_id,
			selected,
			reference,
			answer,
			question,
			edited,
			deleted,
			options,
			comments = "",
			images
		} = q || {};
		return {
			question_id,
			selected,
			deleted,
			edited,
			comments,
			...(images && images.length > 0 ? { images } : {}),
			...(edited
				? {
					revised_question: {
						question,
						options,
						answer,
						reference,
						...(images && images.length > 0 ? { images } : {}),
					},
				}
				: {}),
		};
	});

	return formattedQuestions;
};

export const getFormattedFBQuestions = (questions) => {
	const formattedQuestions = questions.map((q) => {
		const { 
			question_id, 
			selected, 
			reference, 
			question, 
			answer,
			edited, 
			deleted, 
			comments = "",
			images
		} = q || {};
		return {
			question_id,
			selected,
			deleted,
			edited,
			comments,
			...(images && images.length > 0 ? { images } : {}),
			...(edited
				? {
					revised_question: {
						question,
						answer,
						reference,
						...(images && images.length > 0 ? { images } : {}),
					},
				}
				: {}),
		};
	});

	return formattedQuestions;
};


